import { createSelector } from 'reselect';
import { RootState } from 'types/state';
import { APIState } from './reducer';

const getState = (state: RootState) => state.api;

export const getFetchCheckStatusLoading = (state: RootState) => state.api.fetchCheckStatus.isLoading;
export const getFetchFormLoading = (state: RootState) => state.api.fetchForm.isLoading;
export const getFetchIdentityStatusLoading = (state: RootState) => state.api.fetchIdentityStatus.isLoading;
export const getFetchSetAccountLoading = (state: RootState) => state.api.fetchSetAccount.isLoading;
export const getFetchStatusLoading = (state: RootState) => state.api.fetchStatus.isLoading;
export const getFetchEnvironmentLoading = (state: RootState) => state.api.fetchEnvironment.isLoading;
export const getFetchInstituteSearchLoading = (state: RootState) => state.api.fetchInstitutionSearch.isLoading;
export const getSubmitIdentityVerificationLoading = (state: RootState) => state.api.submitIdentityVerification.isLoading;
export const getFetchCheckStatusResponse = (state: RootState) => state.api.fetchCheckStatus.response;
export const getFetchFormResponse = (state: RootState) => state.api.fetchForm.response;
export const getFetchIdentityStatusResponse = (state: RootState) => state.api.fetchIdentityStatus.response;
export const getFetchSetAccountResponse = (state: RootState) => state.api.fetchSetAccount.response;
export const getFetchStatusResponse = (state: RootState) => state.api.fetchStatus.response;
export const getFetchEnvironmentResponse = (state: RootState) => state.api.fetchEnvironment.response;
export const getFetchApiVersionResponse = (state: RootState) => state.api.fetchApiVersion.response;
export const getFetchServerTimeResponse = (state: RootState) => state.api.fetchServerTime.response;
export const getFetchInstituteSearchResponse = (state: RootState) => state.api.fetchInstitutionSearch.response;
export const getAnnouncementsResponse = (state: RootState) => state.api.fetchAnnouncements.response;
export const getSubmitIdentityVerificationResponse = (state: RootState) => state.api.submitIdentityVerification.response;

export const isLoading = (state: RootState) => (
  state.api.fetchCheckStatus.isLoading === true
  || state.api.fetchEnvironment.isLoading === true
  || state.api.fetchForm.isLoading === true
  || state.api.fetchIdentityStatus.isLoading === true
  || state.api.submitIdentityVerification.isLoading === true
  || state.api.fetchSetAccount.isLoading === true
  || state.api.fetchStatus.isLoading === true
);

export const getFetchFormLoaded = (state: RootState) => state.api.fetchForm.formLoaded;

export const hasFetchResponses = createSelector(getState, (state: APIState) => ({
  checkStatus: state.fetchCheckStatus.response !== undefined,
  form: state.fetchForm.response !== undefined,
  identityStatus: state.fetchIdentityStatus.response !== undefined,
  setAccount: state.fetchSetAccount.response !== undefined,
  status: state.fetchStatus.response !== undefined,
  environment: state.fetchEnvironment.response !== undefined,
  apiVersion: state.fetchApiVersion.response !== undefined,
  serverTime: state.fetchServerTime.response !== undefined,
  institutionSearch: state.fetchInstitutionSearch.response !== undefined,
  announcements: state.fetchAnnouncements.response !== undefined,
  identityVerification: state.submitIdentityVerification.response !== undefined,
}));
